import get from 'lodash/get';
import getLocale from './get-locale-from-archetype-content';

export default archetypeContent => get(archetypeContent, `fields[${getLocale(archetypeContent)}].name`);
